<script lang="ts">
  import type { Snippet } from 'svelte';
  import AppProviders from './AppProviders.svelte';
  import RouterOutlet from './RouterOutlet.svelte';

  interface Props {
    children?: Snippet;
  }

  let { children }: Props = $props();
</script>

<AppProviders>
  {#if children}
    {@render children()}
  {:else}
    <RouterOutlet />
  {/if}
</AppProviders>
